/* globals webpackPath */
/* webpackPath Set in htmlHead.isml - used for webpack code splitting path */
__webpack_public_path__ = typeof GLOBAL_KZ.webpackPath === 'undefined' ? '' : GLOBAL_KZ.webpackPath; // eslint-disable-line no-undef, camelcase
